import { Button, ToastMessage } from '@cokitchen/cokitchen-components';
import AddressInput from 'components/base/address-input';
import LocalModal from 'components/base/local-modal';
import useDashboardContext from 'contexts/dashboard.context';
import useAxios from 'hooks/useAxios';
import { BranchAddressType, BranchAddressLocationType } from 'models/branch-address.model';
import { LocationObjectType } from 'models/location.model';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import bulkOrderService from 'services/bulk-order.service';
import { handleApiError } from 'utils/functions';

type Props = {
  isEdit: boolean;
  refetchAllBranchesAddress?: () => void;
  isOpen: boolean;
  onClose: () => void;
  activeAddress?: BranchAddressType | LocationObjectType;
};

const BranchAddressModal = ({
  isOpen,
  onClose,
  isEdit,
  refetchAllBranchesAddress,
  activeAddress
}: Props) => {
  const { activeCompany } = useDashboardContext();

  const { fetchData: saveOrgBranchAddress, loading: isSavingBrandAddress } = useAxios({
    url: `branches/${activeCompany?.id}`,
    method: 'post'
  });
  const { fetchData: editOrgBranchAddress, loading: isEdittingBrandAddress } = useAxios({
    url: `branches/${activeCompany?.id}/${activeAddress?.id}`,
    method: 'patch'
  });

  const [value, setValue] = useState('');

  const handleClose = () => {
    setValue('');
    onClose();
  };
  useEffect(() => {
    setValue(() => (isEdit ? activeAddress?.address ?? '' : ''));
  }, [activeAddress]);

  const handleSaveBranchAddress = async (dataToServer: BranchAddressLocationType) => {
    try {
      await saveOrgBranchAddress({}, dataToServer);
      toast(<ToastMessage message='Address created successfully' type='success' />);
      refetchAllBranchesAddress?.();
      handleClose();
    } catch (err) {
      handleApiError(err);
    } finally {
      handleClose();
    }
  };
  const handleEditBranchAddress = async (dataToServer: BranchAddressLocationType) => {
    try {
      await editOrgBranchAddress({}, dataToServer);
      toast(<ToastMessage message='Address editted successfully' type='success' />);
      refetchAllBranchesAddress?.();
    } catch (err) {
      handleApiError(err);
    } finally {
      handleClose();
    }
  };

  const handleBranchAddress = async () => {
    const formattedAddress = await bulkOrderService.FormatAddress(value, '');

    const dataToServer = {
      latitude: Number(formattedAddress?.lat),
      longitude: Number(formattedAddress?.lng),
      address: formattedAddress?.address
    };
    if (isEdit) {
      handleEditBranchAddress(dataToServer);
      return;
    }
    handleSaveBranchAddress(dataToServer);
  };

  return (
    <LocalModal
      isOpen={isOpen}
      onRequestClose={handleClose}
      title={`${isEdit ? 'Edit' : 'Add'} Branch Address`}>
      <div className='w-full'>
        <AddressInput
          label='Address'
          placeholder='Enter address'
          value={value}
          onChange={setValue}
        />
        <div className='w-full flex gap-4 justify-end'>
          <Button
            variant='block'
            color='gray'
            className='mt-8 h-[41px] w-[139px] !bg-[#F2F2F2] !border-[#F2F2F2] !text-[#2E3031]'
            onClick={handleClose}>
            Cancel
          </Button>
          <Button
            variant='block'
            color='primary'
            className='mt-8 h-[41px] w-[139px]'
            disabled={value === ''}
            loading={isSavingBrandAddress || isEdittingBrandAddress}
            onClick={handleBranchAddress}>
            Save
          </Button>
        </div>
      </div>
    </LocalModal>
  );
};

export default BranchAddressModal;
